import React, { PureComponent, useCallback } from 'react';

import FormikProvider from '../../../shared/forms/formikProvider.component';
import Modal from '../../../shared/modals/modal.component';
import Form from '../../../shared/forms/form.component';

import schema from './countryForm.schema';

import { Country } from '../types';
import { SelectOption } from '../../../shared/types';

const ModalTitles = {
  ADD: 'Add Country',
  EDIT: 'Edit Country',
};

type AddEditCountryModalProps = {
  saveEntity: (
    entityToEdit: Country,
    openForEdit: boolean,
    options: { callback: () => void, keepOpenAfterSaving: boolean }
  ) => void,
  hideModal: () => void,
  entityToEdit: Country,
  openForEdit: boolean,
  isSavingEntity: boolean,
  isVisible: boolean,
  additionalData: {
    lookUpData: {
      currencyCodeOptions: SelectOption[]
    }
  }
};

type AddEditCountryModalState = {
  addAnother: boolean,
};


class AddEditCountryModal extends PureComponent<
  AddEditCountryModalProps,
  AddEditCountryModalState
> {
  state = {
    addAnother: false,
  };

  saveCountry = (
    country: Country,
    { setSubmitting, resetForm }: { setSubmitting: (isSubmitting: boolean) => void, resetForm: () => void }
  ) => {
    const { saveEntity, openForEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, () => {
      saveEntity(country, openForEdit, { callback: resetForm, keepOpenAfterSaving: addAnother });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }: any ) => {
    const {
      openForEdit,
      hideModal,
      isVisible,
      isSavingEntity,
      additionalData,
    } = this.props;

    const submit = useCallback(() => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    }, [formik]);

    const submitAndAddAnotherAction = useCallback(() => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    }, [formik]);

    const reset = useCallback(() => {
      hideModal();
      formik.resetForm();
    }, [formik, hideModal]);

    return (
      <Modal
        className="add-edit-country-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset}
        dismissText="Cancel"
        dismissAction={reset}
        submitText="Save"
        submitAction={submit}
        isSubmitting={formik.isSubmitting || isSavingEntity}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            ...additionalData.lookUpData,
            openForEdit,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.saveCountry as any}
        render={this.renderModal}
      />
    );
  }
}

export default AddEditCountryModal;
